import { useState, type ReactNode } from 'react';
import { Skeleton } from '@heroui/react';

/**
 * Обложка практики с шиммером, пока картинка грузится. Заполняет родителя —
 * размер и скругление задаёт он (`overflow-hidden`). Не загрузилась —
 * `fallback` (иконка/эмодзи на градиенте), а не вечный шиммер.
 *
 * Шиммер тот же, что у скелета карточки (`PracticeCardSkeleton`), — плитка
 * при загрузке списка и при загрузке картинки выглядит одинаково. Он лежит
 * ПОД картинкой и убирается только по `onLoad` этого `<img>`: даже картинка
 * из кэша на новом `<img>` несколько кадров декодируется, и без шиммера под
 * ней в эти кадры была пустая белая плитка (так было с общим «уже загружено»
 * на модуль, которое пропускало шиммер).
 */
export function PracticeCover({
  src,
  fallback,
  lazy = false,
}: {
  src: string;
  fallback: ReactNode;
  lazy?: boolean;
}) {
  const [state, setState] = useState<'loading' | 'ready' | 'failed'>('loading');

  if (state === 'failed') return fallback;

  return (
    <>
      {state === 'loading' && <Skeleton className="absolute inset-0 h-full w-full rounded-none" />}
      <img
        src={src}
        alt=""
        loading={lazy ? 'lazy' : undefined}
        decoding="async"
        onLoad={() => setState('ready')}
        onError={() => setState('failed')}
        className="relative h-full w-full object-cover"
      />
    </>
  );
}
